import { useMemo } from "react";
import type { Command, CommandContext } from "../types";

/**
 * Sprint 26.1 — Routine commands. "New routine" already ships via the create
 * source; this adds "Run routine…", which jumps to the current agent's Routines
 * tab (the shelf of runnable verbs, each with a "Run now" button). When the
 * active context isn't an agent, it falls back to the workforce so the user can
 * pick one. Context-aware so the subtitle names the target.
 */
export function useRoutineCommands(ctx: CommandContext): Command[] {
  const { navigate, currentNodeId, currentNodeType, currentNodeName } = ctx;

  return useMemo<Command[]>(() => {
    const onAgent = currentNodeType === "agent" && !!currentNodeId;
    return [
      {
        id: "routine:run",
        label: "Run routine…",
        icon: "player-play",
        kind: "action",
        subtitle: onAgent ? `Routines · ${currentNodeName ?? "this agent"}` : "Pick an agent",
        keywords: ["run", "routine", "execute", "now", "recurring", "duty"],
        contextAware: true,
        execute: () => navigate(onAgent ? `/agents/${currentNodeId}/routines` : "/workforce"),
      },
    ];
  }, [navigate, currentNodeId, currentNodeType, currentNodeName]);
}
